import React from 'react';
import styled, { CreateStyled } from '@emotion/styled';

export type Theme =
  | 'standard'
  | 'nova'
  | 'flat-slate'
  | 'futuro'
  | 'futuro-dark';
export const ThemeContext = React.createContext<Theme>('standard');

/**
 * Returns styled with the appropriate typing to be used with the ThemeProvider
 *
 * @example
 *
 * type ThemeType = { backgroundColor: string };
 *
 * const ThemedStyled = genThemedStyled<ThemeType>();
 *
 * const themes = {
 *   'dark': { backgroundColor: '#000' },
 *   'light: { backgroundColor: '#FFF' },
 * };
 *
 * const Wrapper = ThemeStyled('div')`
 *   background-color: ${p => p.theme.backgroundColor};
 * `;
 *
 * const Foo = () => {
 *   const themeContext = useContext(ThemeContext);
 *   return (
 *     <ThemeProvider theme={themes[themeContext]} >
 *       <Wrapper>Foo!</Wrapper>
 *     </ThemeProvider>
 *   );
 * }
 */
export const genThemedStyled = <T extends {}>() => styled as CreateStyled<T>;
